import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';

require('moment/locale/el');

const DeliverableIdHiddenInput = ({item, itemKey}) => {
    if (!item || !item.id) {
        return null;
    }

    return (
        <input
            type="hidden"
            name={"deliverables[" + itemKey + "][deliverable_id]"}
            value={item.id}
        />
    );
};

const DeliverableAttachmentLink = ({item}) => {
    if (!item || !item.attachment_url) {
        return null;
    }

    return (
        <a target="_blank" href={item.attachment_url}>
            <i className="fa fa-cloud-download"></i> {window.__js_contracts.download_current_file}
        </a>
    );
};

export default class ContractDeliverable extends Component {
    constructor() {
        super();

        this.state = {
            units: [],
            key: 0,
            title: "",
            deadline_formatted: moment()
        };

        this.removeItem = this.removeItem.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleDeadlineChange = this.handleDeadlineChange.bind(this);
    }

    componentWillMount() {
        let item = this.props.item;

        let deadline_formatted = moment();
        if (item.deadline_formatted === null)
            deadline_formatted = moment();
        else if (item.deadline_formatted === "")
            deadline_formatted = "";
        else
            deadline_formatted = moment(item.deadline_formatted, "DD/MM/YYYY");

        this.setState({
            key: item.key,
            title: item.title,
            deadline_formatted: deadline_formatted,
        });
    }

    handleTitleChange(e) {
        this.setState({title: e.target.value});
    }

    handleDeadlineChange(date) {
        this.setState({deadline_formatted: date});
    }

    removeItem() {
        this.props.removeFn(this.state.key);
    }

    render() {
        const {item} = this.props;

        return (
            <tr>
                <td>
                    <input type="text"
                           name={"deliverables[" + this.state.key + "][title]"}
                           value={this.state.title}
                           className="form-control"
                           onChange={this.handleTitleChange}/>
                    <DeliverableIdHiddenInput item={item} itemKey={this.state.key}/>
                </td>
                <td>
                    <DatePicker className="form-control"
                                name={"deliverables[" + this.state.key + "][deadline_formatted]"}
                                selected={this.state.deadline_formatted}
                                onChange={this.handleDeadlineChange}
                                dateFormat="DD/MM/YYYY"
                                locale="el"/>
                </td>
                <td>
                    <input type="file"
                           name={"deliverables[" + this.state.key + "][attachment]"}
                           className="form-control"/>
                    <DeliverableAttachmentLink item={item}/>
                </td>
                <td>
                    <Button onClick={this.removeItem}
                            bsStyle="danger">
                        <i className="fa fa-minus"></i>
                    </Button>
                </td>
            </tr>
        );
    }
}